import styled, { css } from "styled-components";
import { Wrapper } from "AppReact";

const template = styled.div`
  ${({ displayState }) => css`
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
    border-radius: 16px;
    position: relative;
    width: 230px;
    height: 130px;
    aspect-ratio: 1.769;
    overflow: hidden;
  `}
`;

export default Wrapper(template);
